import { TablePaginationConfig } from 'antd/lib/table/interface'
import { IPagination } from '@/model/types/common'

export const MEMBER_TABLE_PAGE_SIZE = 20

export const MEMBER_TABLE_PAGE_SIZE_OPTIONS = ['10', '20', '50', '100']

export const getTableTotal = (pagination?: IPagination) => {
    if (!pagination) return 0

    if (typeof pagination.total_count === 'number') return pagination.total_count

    return pagination.page_count * pagination.limit
}

export interface MemberTablePaginationParams {
    current: number
    pageSize: number
    total: number
    onChange: (page: number, pageSize?: number) => void
    onShowSizeChange: (current: number, size: number) => void
}

/**
 * 会员模块统一分页配置：底部分页居中，支持跳转指定页与切换每页条数。
 */
export const getMemberTablePagination = (params: MemberTablePaginationParams): TablePaginationConfig => ({
    position: ['bottomCenter'],
    current: params.current,
    pageSize: params.pageSize,
    total: params.total,
    showSizeChanger: true,
    showQuickJumper: true,
    pageSizeOptions: MEMBER_TABLE_PAGE_SIZE_OPTIONS,
    showTotal: (total: number) => `共 ${total} 条`,
    onChange: params.onChange,
    onShowSizeChange: params.onShowSizeChange,
})
